
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as adminDMw_1LWmT_458ChPUqgY6pCnASqpOJraouDvz9hW2XUyIMeta } from "/home/ubuntu/Lagerverwaltung/pages/admin.vue?macro=true";
import { default as indexRSGOqE1_jj4ZmZSkOskdOHAn9UH2XO6qr4Gx1jILAPEMeta } from "/home/ubuntu/Lagerverwaltung/pages/index.vue?macro=true";
import { default as items_45Gwjh6fGWw1NFXu54gSbu1a8P5YL_AbcnbczkAa_45mjUMeta } from "/home/ubuntu/Lagerverwaltung/pages/items.vue?macro=true";
import { default as craftingrAHidFj3M0XoYf0ds9z0BYZpW_k0Fg4efr6Q2eXpVYkMeta } from "/home/ubuntu/Lagerverwaltung/pages/crafting.vue?macro=true";
import { default as settings87IkOts_CIYtd9_WiA0YHu2nsLEoHIHXGmBXLRfvDV0Meta } from "/home/ubuntu/Lagerverwaltung/pages/settings.vue?macro=true";
import { default as storagesQmiSy6V_hqI9UfQBRnOAcu6oDtUwaeYPWnnTol8lV8oMeta } from "/home/ubuntu/Lagerverwaltung/pages/storages.vue?macro=true";
import { default as _91id_93X5_455jjaLMmBPIJV1FbkLqzQfP3X0KZ_nR8cs4M2A_8IMeta } from "/home/ubuntu/Lagerverwaltung/pages/item/[id].vue?macro=true";
import { default as loginVX2tz6cAH7gMAQ5_4523538zfghHGeOVmX6180hZLgWA4Meta } from "/home/ubuntu/Lagerverwaltung/pages/auth/login.vue?macro=true";
import { default as _91id_93ywGNrPsJq340JImm_45KH811N2wM78w1NjHFzmdz277MoMeta } from "/home/ubuntu/Lagerverwaltung/pages/storage/[id].vue?macro=true";
import { default as activity_45logsmIiDH3yQ7kEPGLU74w8iDWgudj61KIy2o6melG10y6gMeta } from "/home/ubuntu/Lagerverwaltung/pages/activity-logs.vue?macro=true";
import { default as registerEmWcHBFEyWw_dhzyOgv0zBWgGpzv8cZ9CvM9K2ngshQMeta } from "/home/ubuntu/Lagerverwaltung/pages/auth/register.vue?macro=true";
export default [
  {
    name: "admin___en",
    path: "/en/admin",
    meta: { ...(adminDMw_1LWmT_458ChPUqgY6pCnASqpOJraouDvz9hW2XUyIMeta || {}), ...{"middleware":["sidebase-auth","admin"]} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/admin.vue")
  },
  {
    name: "admin___de",
    path: "/admin",
    meta: { ...(adminDMw_1LWmT_458ChPUqgY6pCnASqpOJraouDvz9hW2XUyIMeta || {}), ...{"middleware":["sidebase-auth","admin"]} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/admin.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexRSGOqE1_jj4ZmZSkOskdOHAn9UH2XO6qr4Gx1jILAPEMeta || {},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/",
    meta: indexRSGOqE1_jj4ZmZSkOskdOHAn9UH2XO6qr4Gx1jILAPEMeta || {},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/index.vue")
  },
  {
    name: "items___en",
    path: "/en/items",
    meta: { ...(items_45Gwjh6fGWw1NFXu54gSbu1a8P5YL_AbcnbczkAa_45mjUMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/items.vue")
  },
  {
    name: "items___de",
    path: "/items",
    meta: { ...(items_45Gwjh6fGWw1NFXu54gSbu1a8P5YL_AbcnbczkAa_45mjUMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/items.vue")
  },
  {
    name: "crafting___en",
    path: "/en/crafting",
    meta: { ...(craftingrAHidFj3M0XoYf0ds9z0BYZpW_k0Fg4efr6Q2eXpVYkMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/crafting.vue")
  },
  {
    name: "crafting___de",
    path: "/crafting",
    meta: { ...(craftingrAHidFj3M0XoYf0ds9z0BYZpW_k0Fg4efr6Q2eXpVYkMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/crafting.vue")
  },
  {
    name: "settings___en",
    path: "/en/settings",
    meta: {"middleware":"sidebase-auth"},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/settings.vue")
  },
  {
    name: "settings___de",
    path: "/settings",
    meta: {"middleware":"sidebase-auth"},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/settings.vue")
  },
  {
    name: "storages___en",
    path: "/en/storages",
    meta: { ...(storagesQmiSy6V_hqI9UfQBRnOAcu6oDtUwaeYPWnnTol8lV8oMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/storages.vue")
  },
  {
    name: "storages___de",
    path: "/storages",
    meta: { ...(storagesQmiSy6V_hqI9UfQBRnOAcu6oDtUwaeYPWnnTol8lV8oMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/storages.vue")
  },
  {
    name: "item-id___en",
    path: "/en/item/:id()",
    meta: { ...(_91id_93X5_455jjaLMmBPIJV1FbkLqzQfP3X0KZ_nR8cs4M2A_8IMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/item/[id].vue")
  },
  {
    name: "item-id___de",
    path: "/item/:id()",
    meta: { ...(_91id_93X5_455jjaLMmBPIJV1FbkLqzQfP3X0KZ_nR8cs4M2A_8IMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/item/[id].vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: loginVX2tz6cAH7gMAQ5_4523538zfghHGeOVmX6180hZLgWA4Meta || {},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/auth/login.vue")
  },
  {
    name: "auth-login___de",
    path: "/auth/login",
    meta: loginVX2tz6cAH7gMAQ5_4523538zfghHGeOVmX6180hZLgWA4Meta || {},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/auth/login.vue")
  },
  {
    name: "storage-id___en",
    path: "/en/storage/:id()",
    meta: { ...(_91id_93ywGNrPsJq340JImm_45KH811N2wM78w1NjHFzmdz277MoMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/storage/[id].vue")
  },
  {
    name: "storage-id___de",
    path: "/storage/:id()",
    meta: { ...(_91id_93ywGNrPsJq340JImm_45KH811N2wM78w1NjHFzmdz277MoMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/storage/[id].vue")
  },
  {
    name: "activity-logs___en",
    path: "/en/activity-logs",
    meta: { ...(activity_45logsmIiDH3yQ7kEPGLU74w8iDWgudj61KIy2o6melG10y6gMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/activity-logs.vue")
  },
  {
    name: "activity-logs___de",
    path: "/activity-logs",
    meta: { ...(activity_45logsmIiDH3yQ7kEPGLU74w8iDWgudj61KIy2o6melG10y6gMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/activity-logs.vue")
  },
  {
    name: "auth-register___en",
    path: "/en/auth/register",
    meta: registerEmWcHBFEyWw_dhzyOgv0zBWgGpzv8cZ9CvM9K2ngshQMeta || {},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/auth/register.vue")
  },
  {
    name: "auth-register___de",
    path: "/auth/register",
    meta: registerEmWcHBFEyWw_dhzyOgv0zBWgGpzv8cZ9CvM9K2ngshQMeta || {},
    component: () => import("/home/ubuntu/Lagerverwaltung/pages/auth/register.vue")
  }
]